/*
 * Copyright (C) 2018 BarD Software s.r.o
 */

import {Prop, Component, Vue} from 'vue-facing-decorator';
import {updateDependencies} from '../Dashboard';
import {CancelInvite, TeamJoin} from '../Routes';
import {InviteDto, loadTeam, TeamDto} from '../Teams';
import {handleXhrError} from '../utils/Ui';

@Component
export default class InviteItem extends Vue {
    @Prop()
    public invite: InviteDto;

    @Prop()
    public team: TeamDto;

    public cancelInvite() {
        CancelInvite.invoke({ code: this.invite.code })
            .then(() => loadTeam(this.team.refid))
            .then(updateDependencies)
            .fail((jqXhr) => handleXhrError(jqXhr, 'Fail to cancel invitation'));
    }

    public copyInviteLink() {
        const link = TeamJoin.absoluteUrl({
            code: this.invite.code,
            action: 'Preview',
        });
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link);
        } else {
            const textarea = document.createElement('textarea');
            textarea.textContent = link;
            document.body.appendChild(textarea);

            const selection = document.getSelection();
            const range = document.createRange();
            range.selectNode(textarea);
            selection.removeAllRanges();
            selection.addRange(range);

            document.execCommand('copy');
            selection.removeAllRanges();
            document.body.removeChild(textarea);
        }
    }
}
